var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('md-button',{staticClass:"md-icon-button",nativeOn:{"click":function($event){return _vm.visualizationMode()}}},[_c('md-icon',[_vm._v("visibility")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }